import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, ArrowUpRight } from "lucide-react";
import { company, nav } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0B102D]/95 backdrop-blur shadow-lg py-2" : "bg-gradient-to-b from-black/50 to-transparent py-4"
      }`}
    >
      <div className="max-w-[1320px] mx-auto px-5 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center group">
          <img
            src="/salmons-logo.png"
            alt="Salmons Brothers logo"
            className="h-11 w-auto object-contain shrink-0 transition-transform group-hover:scale-[1.03]"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `font-display text-[15px] font-semibold uppercase tracking-wide transition-colors ${
                  isActive ? "text-[#CD0008]" : "text-white hover:text-[#CD0008]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Right */}
        <div className="flex items-center gap-4">
          <a
            href={company.phoneHref}
            className="hidden xl:flex items-center gap-2 text-white/90 hover:text-[#CD0008] transition-colors"
          >
            <Phone size={18} />
            <span className="font-display font-semibold text-sm">{company.phone}</span>
          </a>
          <Link
            to="/contact"
            className="hidden sm:inline-flex items-center gap-2 bg-[#CD0008] hover:bg-[#A80006] text-white font-display font-semibold text-sm uppercase tracking-wide px-6 py-3 rounded-sm transition-colors"
          >
            Get a Quote <ArrowUpRight size={16} />
          </Link>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={26} />
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`fixed inset-0 z-50 lg:hidden transition-opacity ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
        <div
          className={`absolute right-0 top-0 h-full w-[280px] bg-[#0B102D] p-6 flex flex-col transition-transform duration-300 ${
            open ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between mb-8">
            <img src="/salmons-logo.png" alt="Salmons Brothers logo" className="h-8 w-auto object-contain" />
            <button onClick={() => setOpen(false)} className="text-white" aria-label="Close menu">
              <X size={24} />
            </button>
          </div>
          <nav className="flex flex-col gap-1">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `font-display font-semibold uppercase tracking-wide py-3 border-b border-white/10 ${
                    isActive ? "text-[#CD0008]" : "text-white"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <a
            href={company.phoneHref}
            className="mt-8 flex items-center gap-2 text-white/80"
          >
            <Phone size={18} /> {company.phone}
          </a>
          <Link
            to="/contact"
            className="mt-4 inline-flex items-center justify-center gap-2 bg-[#CD0008] text-white font-display font-semibold uppercase tracking-wide px-6 py-3 rounded-sm"
          >
            Get a Quote <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
